import axios from '@/utils/http'

/**
 *
 * 获取反馈列表
 * @export
 * @param {*} params
 * @returns
 */
export function getFeedbackList(params) {
  return axios({
    url: '/MenuService/Feedback/GetFeedbacks',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取反馈类型
 * @export
 * @param {*} params
 * @returns
 */
export function getFeedbackTypeList(params) {
  return axios({
    url: '/MenuService/Feedback/GetFeedbackType',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 删除反馈
 * @export
 * @param {*} params
 * @returns
 */
export function delFeedback(params) {
  return axios({
    url: '/MenuService/Feedback/DelFeedback',
    method: 'post',
    data: params
  })
}
